const VALIDATE_DISCOUNT_CODE = {
  REQUEST: 'VALIDATE_DISCOUNT_CODE_REQUEST',
  SUCCESS: 'VALIDATE_DISCOUNT_CODE_SUCCESS',
  FAILURE: 'VALIDATE_DISCOUNT_CODE_FAILURE',
};

const APPLY_DISCOUNT_CODE = {
  REQUEST: 'APPLY_DISCOUNT_CODE_REQUEST',
  SUCCESS: 'APPLY_DISCOUNT_CODE_SUCCESS',
  FAILURE: 'APPLY_DISCOUNT_CODE_FAILURE',
};

const FETCH_DISCOUNT_CODES = {
  REQUEST: 'FETCH_DISCOUNT_CODES_REQUEST',
  SUCCESS: 'FETCH_DISCOUNT_CODES_SUCCESS',
  FAILURE: 'FETCH_DISCOUNT_CODES_FAILURE',
};

const CREATE_DISCOUNT_CODE = {
  REQUEST: 'CREATE_DISCOUNT_CODE_REQUEST',
  SUCCESS: 'CREATE_DISCOUNT_CODE_SUCCESS',
  FAILURE: 'CREATE_DISCOUNT_CODE_FAILURE',
};

const UPDATE_DISCOUNT_CODE = {
  REQUEST: 'UPDATE_DISCOUNT_CODE_REQUEST',
  SUCCESS: 'UPDATE_DISCOUNT_CODE_SUCCESS',
  FAILURE: 'UPDATE_DISCOUNT_CODE_FAILURE',
};

const DELETE_DISCOUNT_CODE = {
  REQUEST: 'DELETE_DISCOUNT_CODE_REQUEST',
  SUCCESS: 'DELETE_DISCOUNT_CODE_SUCCESS',
  FAILURE: 'DELETE_DISCOUNT_CODE_FAILURE',
};

const RESET_DISCOUNT_STATE = 'RESET_DISCOUNT_STATE';
const RESET_DISCOUNT_MESSAGE = 'RESET_DISCOUNT_MESSAGE';

export default {
  VALIDATE_DISCOUNT_CODE,
  APPLY_DISCOUNT_CODE,
  FETCH_DISCOUNT_CODES,
  CREATE_DISCOUNT_CODE,
  UPDATE_DISCOUNT_CODE,
  DELETE_DISCOUNT_CODE,
  RESET_DISCOUNT_STATE,
  RESET_DISCOUNT_MESSAGE,
};